import React from 'react'

const Main = (props) => {
  return (
    <div className="bg-[#FDF5EE] overflow-hidden ml-[2rem] w-[calc(100vw-100px)] xs:w-screen h-[calc(100vh-40px)] xs:h-[calc(100vh-80px)] mt-[20px] xs:mt-[80px] flex xs:justify-center xs:items-end rounded-l-[20px] xs:rounded-[10px]">{props.children}</div>
  )
}

export default Main